// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1UETpfsW9B","summary":"summary-2VyqPyIi5Z","item":"item-1ZJ4SJi63X","controls":"controls-2TL2lk_YmC item-1ZJ4SJi63X","chart":"chart-2XRiaSexBb item-1ZJ4SJi63X"};